import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { viewer } from 'modules/common/viewer/data/actions';
import { getIsLegacyDxfViewerForPartFile } from 'modules/common/viewer/data/reducer';

import { useAppSelector } from 'store/hooks';

/* Legacy DXF Viewer Toggle */
export const useLegacyDxfViewerToggle = (activePartFileUuid: string | null) => {
  const dispatch = useDispatch();
  const isLegacyDxfViewer = useAppSelector((state) =>
    getIsLegacyDxfViewerForPartFile(state, activePartFileUuid),
  );
  const setIsLegacyDxfViewer = useCallback(
    (nextIsLegacyDxfViewer: boolean) => {
      if (!activePartFileUuid) {
        return;
      }
      dispatch(
        viewer.setLegacyDxfViewerForPartFile({
          partFileUuid: activePartFileUuid,
          isLegacyDxfViewer: nextIsLegacyDxfViewer,
        }),
      );
    },
    [dispatch, activePartFileUuid],
  );

  return { isLegacyDxfViewer, setIsLegacyDxfViewer };
};
